import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.personId)?_c('div',{attrs:{"id":"personAvailability"}},[_c(VCard,{},[_c('person-availability-table',{attrs:{"person-id":_vm.personId}})],1)],1):_c('div',[_c(VCard,{staticClass:"pa-3"},[_c('p',[_vm._v("No availability found")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }